import React, { useContext, useEffect } from "react"
import i18n from "i18n"
import { API, Auth } from "aws-amplify"
import { Grid } from "@mui/material"
import AuthContext from "context/auth/authContext"
import { LinkAsOutlinedButton } from "components/Feed/CustomStyles"

const PricingPage = () => {
  const { user } = useContext(AuthContext)
  useEffect(() => {
    if (window.Pricify) {
      window.Pricify.openPricingPage({
        pricingPage: async () => {
          const CORE = "CORE"

          const headers = {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
            "Access-Control-Allow-Origin": "*",
          }

          const body = {
            customer_id: user["custom:organizationId"],
          }

          const res = await API.post(CORE, "/chargebee/pricing_page", {
            headers: headers,
            body: body,
          })

          return res
        },
      })
    }
  }, [])

  return (
    <Grid>
      <Grid item container justifyContent="flex-end">
        <LinkAsOutlinedButton href="javascript:void(0)" data-cb-type="portal">
          {i18n.t("manageAccount")}
        </LinkAsOutlinedButton>
      </Grid>
      <Grid item>
        <div
          id="pricify-hosted-pricing-page"
          data-pricify-integrationtype="api"
        ></div>
      </Grid>
    </Grid>
  )
}

export default PricingPage
